import React, { FC, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Moment } from 'moment';

// types
import { HistogramData } from 'ducks/merchantDucks/reports/types';

// utils
import { format } from 'pages/MerchantPages/Analytics/Analytics';

// actions
import { fetchAssetPaymentPerCountry } from 'ducks/merchantDucks/payments/actions';

// components
import PaymentCharts from 'pages/MerchantPages/Assets/components/ItemAnalytics/PaymentCharts';

// selectors
import { getAssetPaymentPerCountry } from 'ducks/merchantDucks/payments/selectors';

type Props = {
  startDate: Moment;
  endDate: Moment;
};

const PaymentTiles: FC<Props> = ({ startDate, endDate }) => {
  const dispatch = useDispatch();
  const { id } = useParams<{ id: string }>();
  const assetPaymentPerCountry = useSelector(getAssetPaymentPerCountry);

  useEffect(() => {
    dispatch(fetchAssetPaymentPerCountry(Number(id), startDate.format(format), endDate.format(format)));
  }, [startDate, endDate]);

  const renderPaymentTiles = useMemo(() => {
    let data: Array<HistogramData> = [];
    const { isFetching, collection } = assetPaymentPerCountry;
    if (collection) {
      const asset = assetPaymentPerCountry.collection.find((item) => item.item_id === Number(id));
      if (asset && asset.countries) {
        data = asset.countries.map((country) => ({ key: country.country_iso, doc_count: country.value })).slice(0, 10);
      }
    }
    return (
      <PaymentCharts
        data={data}
        startDate={startDate.toString()}
        endDate={endDate.toString()}
        isFetching={isFetching}
      />
    );
  }, [assetPaymentPerCountry]);

  return renderPaymentTiles;
};

export default PaymentTiles;
